<template>
  <div>
    <Dialog
      :visible.sync="filterForm1"
      :style="{ width: '750px', overflowY: 'auto' }"
      header="Filter Details"
      :modal="true"
      class="p-fluid"
    >
      <div>
        <div class="p-grid">
          <div class="p-col-12 p-md-8 p-lg-10">
            <label for="filter1">Description</label>
            <InputText
              placeholder="Click button to search for customer"
              v-model="filterDetails.filterName"
            />
            <small
              class="p-invalid"
              v-if="submitted && !filterDetails.filterName"
              >FilterName is required.</small
            >
          </div>
          <div class="p-col-12 p-md-4 p-lg-2">
            <div class="p-field-checkbox" style="padding-top: 35px;">
              <Checkbox
                id="binary"
                v-model="filterDetails.defaultView"
                :binary="true"
              />
              <label for="filter2">Default View</label>
            </div>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-md-8 p-lg-10">
            <InputText
              placeholder="Order By Clause"
              disabled="true"
              v-model="strToShow"
            />
            <small
              class="p-invalid"
              v-if="submitted && !filterDetails.orderByClause"
              >Order By Clause is required.</small
            >
          </div>
          <div class="p-col-12 p-md-4 p-lg-2">
            <div class="p-field-checkbox" style="padding-top: 3px;">
              <!-- <Checkbox 
                id="binary" 
                v-model="filterDetails.defaultView" 
                :binary="true" 
              /> -->
              <!-- :class="favorite ? 'p-button-sm p-button-rounded p-button-danger p-button-text' : 'p-button-sm p-button-rounded p-button-danger p-button-outlined p-button-text'"  -->
              <Button
                :icon="favorite ? 'pi pi-star' : 'pi pi-star-o'"
                class="p-button-rounded p-button-danger p-button-outlined p-button-text"
                @click="favorite = !favorite"
              />
              <label for="filter2">Favorite</label>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        header="Condition"
        :visible.sync="conditionSelection"
        :style="{ width: '750px', minHeight: '400px', overflowY: 'auto' }"
      >
        <div class="row" style="min-height: 300px;">
          <div class="col col-md-6 col-lg-2">
            <label for="filter1">AND/OR</label>
            <Dropdown
              v-model="filter1"
              :options="filters1"
              optionLabel="value"
              dataKey="id"
              placeholder="------"
              :showClear="true"
            />
            <small class="p-invalid" v-if="isField1Required"
              >This field is required.</small
            >
          </div>
          <div class="col col-md-6 col-lg-3">
            <label for="filter2">Field</label>
            <Dropdown
              v-model="filter2"
              :options="filters2"
              optionLabel="fieldName"
              dataKey="id"
              placeholder="------"
              :showClear="true"
            />
            <small
              class="p-invalid"
              v-if="fieldsEntered && !(filter2 && filter2.id)"
              >This field is required.</small
            >
          </div>
          <div class="col col-md-6 col-lg-3">
            <label for="filter3">Comparison</label>
            <Dropdown
              v-model="filter3"
              :options="filters3"
              optionLabel="value"
              dataKey="id"
              placeholder="------"
              :showClear="true"
            />
            <small
              class="p-invalid"
              v-if="fieldsEntered && !(filter3 && filter3.id)"
              >This field is required.</small
            >
          </div>
          <div class="col col-md-6 col-lg-4">
            <label for="filter4">Value</label>
            <!-- <Dropdown
              v-model="filter4"
              :options="filters4"
              :optionLabel="get4Label()"
              :dataKey="getDataKey()"
              placeholder="------"
              :showClear="true"
            /> -->
            <CustomDropDown
              v-if="
                (filter4Type === 'Array' || filter4Type === 'Date') &&
                  filter2.filterAutocomplete
              "
              :allOptions="filters4"
              :disabled="false"
              :optionLabel="get4Label()"
              :dataKey="getDataKey()"
              :forceSelection="!filter2.filterAllowStartWith"
              :showDropDownOnStart="filter2.filterDropdown"
              :currentValue="filter4"
              placeholder="------"
              style="width: 100%"
              @selected="setSelection"
            >
            </CustomDropDown>
            <Dropdown
              v-else-if="
                (filter4Type === 'Array' || filter4Type === 'Date') &&
                  !filter2.filterAutocomplete
              "
              v-model="filter4"
              :options="filters4"
              :optionLabel="get4Label()"
              :dataKey="getDataKey()"
              placeholder="------"
              :showClear="true"
            />
            <Dropdown
              v-else-if="filter4Type === 'Yes/No'"
              v-model="filter4"
              :options="filters4"
              optionLabel="parentFlag"
              dataKey="id"
              placeholder="------"
              :showClear="true"
            />
            <InputMask
              v-else-if="filter4Type === 'Time'"
              mask="99:99"
              v-model="filter4"
              slotChar="hh/mm"
            />
            <InputText
              v-else-if="filter4Type === 'String'"
              id="filter4Type"
              v-model.trim="filter4"
              required="false"
            />
            <InputNumber
              v-else-if="filter4Type === 'Number' || filter4Type === 'Currency'"
              id="filter4Type"
              v-model.trim="filter4"
              required="false"
            />
            <br />
            <InputMask
              v-if="filter4 && filter4.dateModifierFunc === 'custom'"
              mask="99/99/9999"
              v-model="tempDate"
              slotChar="dd/mm/yyyy"
              placeholder="Date from"
              style="width: 100%;"
            />
            <small class="p-invalid" v-if="fieldsEntered && !filter4"
              >This field is required.</small
            >
          </div>
        </div>
        <template #footer>
          <div class="row">
            <div class="col col-md-8 col-lg-10"></div>
            <div class="col col-md-4 col-lg-2">
              <Button
                v-if="conditionsEditIndex >= 0"
                label="Update"
                icon="pi pi-check"
                class="p-button-text"
                @click="edit"
              />
              <Button
                v-else
                label="Add"
                icon="pi pi-check"
                class="p-button-text"
                @click="add"
              />
            </div>
          </div>
        </template>
      </Dialog>

      <br />

      <DataTable
        :value="filters"
        class="p-datatable-sm"
        dataKey="oppId"
        :rowHover="true"
        :key="tableKey"
        style="min-height: 300px;"
      >
        <template #header>
          <div class="table-header">
            Filter Conditions
            <Button
              @click="openConditionDialog"
              icon="pi pi-plus"
              style="float:right;"
            />
          </div>
        </template>
        <Column field="AND/OR" header="AND/OR" headerStyle="width: 3em">
          <template #body="slotProps">
            {{ slotProps.data.gate }}
          </template>
        </Column>
        <Column field="Field" header="Field" headerStyle="width: 6em">
          <template #body="slotProps">
            {{ slotProps.data.fieldToView || slotProps.data.field }}
          </template>
        </Column>
        <Column field="Comparison" header="Comparison" headerStyle="width: 3em">
          <template #body="slotProps">
            {{ slotProps.data.comparison }}
          </template>
        </Column>
        <Column field="Value" header="Value" headerStyle="width: 6em">
          <template #body="slotProps">
            {{ slotProps.data.value }}
          </template>
        </Column>
        <Column field="remove" header="Remove" headerStyle="width: 4em">
          <template #body="slotProps">
            <Button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success"
              @click="editCondition(slotProps.data)"
            />
            <Button
              icon="pi pi-times"
              class="p-button-rounded p-button-danger"
              @click="removeCondition(slotProps.data)"
            />
          </template>
        </Column>
      </DataTable>

      <br />

      <template #footer>
        <Button
          style="float: left;"
          label="Select Fields to Sort By"
          class="p-button-info"
          @click="selectFieldsToSortBy()"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="close"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="addFilter"
        />
      </template>
    </Dialog>

    <!-- :dbViewFields="filters2" -->
    <SortByFields
      :key="sortByFieldsKey"
      :sortByFieldsDialog="sortByFieldsDialog"
      :dbViewFields="dbViewFields"
      :sortByFieldsClause="orderByClause"
      @close="
        () => {
          this.sortByFieldsDialog = false;
        }
      "
      @sortByFieldString="sortByFieldString"
      @strToShow="getOrderByClauseFromChild"
    />
  </div>
</template>

<script>
import { withPickerLabels, pickerLabelKey } from "./pickerLabels";
import moment from "moment";

import CustomerService from "../../../service/CustomerService";
import FiltersService from "../../../service/FiltersSerice";

import SortByFields from "./sortByFields";

import { filterSaveRequest } from "../sendRequest";

import { conditionValueFor, findConditionOptionById, pickedDbValue } from "./conditionValue";

export default {
  components: {
    SortByFields
  },
  props: {
    filterForm: {
      type: Boolean,
      required: true
    },
    getDBViewFieldsId: {
      type: Number,
      required: true
    },
    filterToEdit: {
      type: Object,
      required: false
    },
    excludeArray: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: () => ({
    filtersService: new FiltersService(),
    customerService: new CustomerService(),
    filterDetails: {
      id: null,
      dbview: {},
      user: {},
      filterName: "",
      defaultView: false,
      whereClause: "",
      orderByClause: ""
    },
    filters: [],
    filter1: {},
    filters1: [
      { id: 1, value: "AND" },
      { id: 2, value: "OR" }
    ],
    filter2: {},
    filters2: [],
    filter3: {},
    filters3Data: [
      { id: 1, value: "=" },
      { id: 2, value: "≠" },
      { id: 3, value: "<" },
      { id: 4, value: ">" },
      { id: 5, value: "<=" },
      { id: 6, value: ">=" },
      { id: 7, value: "equals" },
      { id: 8, value: "does not equal" },
      { id: 9, value: "begins with" },
      { id: 10, value: "contains" }
    ],
    filters3: [],
    filter4: null,
    filters4Data: [],
    filter4Type: "",
    filters4: [],
    submitted: false,
    conditionSelection: false,
    sortByFieldsDialog: false,
    orderByClause: "",
    strToShow: "",
    sortByFieldsKey: 0,
    conditionsEditIndex: -1,
    dbViewFields: [],
    fieldsEntered: false,
    users: [],
    contacts: [],
    sendingRequest: false,
    yesFlag: { id: 1, parentFlag: "Yes" },
    noFlag: { id: 2, parentFlag: "No" },
    dateModifiers: [],
    showWarning: false,
    tempDate: "",
    filterToEditConditions: [],
    tableKey1: 0,
    favorite: false
  }),
  computed: {
    isField1Required() {
      //
      if (this.conditionsEditIndex >= 0) {
        return (
          this.fieldsEntered &&
          this.conditionsEditIndex > 0 &&
          !(this.filter1 && this.filter1.id)
        );
      } else {
        return (
          this.fieldsEntered &&
          this.filters &&
          this.filters.length > 0 &&
          !(this.filter1 && this.filter1.id)
        );
      }
    },
    filterForm1: {
      set(val) {
        if (!val) {
          this.close();
        }
      },
      get() {
        return this.filterForm;
      }
    },
    tableKey: {
      set(val) {
        this.tableKey1++;
      },
      get() {
        return "tableKey-" + this.tableKey1.toString();
      }
    }
  },
  created() {
    if (this.filterToEdit && this.filterToEdit.id) {
      if (
        this.filterToEdit.favourite !== null ||
        this.filterToEdit.favourite !== undefined
      ) {
        this.favorite = this.filterToEdit.favourite;
      }

      this.filterDetails.filterName = this.filterToEdit.filterName;
      this.filterDetails.id = this.filterToEdit.id;
      this.filterDetails.defaultView = this.filterToEdit.defaultView;

      this.filtersService
        .getUserViewFilterConditiosn(this.filterToEdit.id)
        .then(data => (this.filterToEditConditions = data))
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: `Error while getting filter conditions.`,
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "userViewFilterConditions/{filterId}"'
          });
        });

      this.constructSortOrder();
    } else {
      this.filtersService
        .getDBView(this.getDBViewFieldsId)
        .then(data => {
          //
          if (data && data.id && data.idField && data.viewName) {
            let str = `${data.idField} DESC`,
              strToShow = `${data.viewName} DESC`;
            this.sortByFieldString({ str, strToShow });
          }
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting db view",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "dbView/{dbView}"'
          });
        });
    }

    this.filtersService
      .getDBViewFields(this.getDBViewFieldsId)
      .then(data => {
        this.filtersService
          .getDateModifiers()
          .then(dateModifiers => {
            this.dateModifiers = dateModifiers;
            //
            // var dateModifiers = data1.filter(data2 => data2.dateModifierFunc !== 'custom')

            this.dbViewFields = data;
            this.constructSortOrder();

            data.forEach(d => {
              //
              if (!this.excludeArray.includes(d.fieldName)) {
                // if (d.lovEP) {
                if (d.canFilter && d.active) {
                  //
                  this.filters2.push(d);
                  this.filters4Data.push(d);
                  if (d.fieldType === "Date") {
                    let c = this.filters4Data.findIndex(e => e.id === d.id);
                    this.filters4Data[c] = dateModifiers;
                  } else if (d.fieldType === "Time") {
                    let c = this.filters4Data.findIndex(e => e.id === d.id);
                    this.filters4Data[c] = "";
                  } else if (d.lovEP) {
                    if (d.lovEP === "YES/NO") {
                      let c = this.filters4Data.findIndex(e => e.id === d.id);
                      this.filters4Data[c] = [
                        { id: 1, [d.dbField]: "Yes" },
                        { id: 2, [d.dbField]: "No" }
                      ];
                    } else if (d.lovEP.substr(0, 1) === "*") {
                      let c = this.filters4Data.findIndex(e => e.id === d.id);
                      let list = d.lovEP.substr(1).split("/");
                      if (list.length) {
                        this.filters4Data[c] = list.map((a, index) => {
                          return { id: index, [d.dbField]: a };
                        });
                      }
                    } else if (d.lovEP) {
                      this.filtersService
                        .filtersCustomRequest(d.lovEP)
                        .then(data => {
                          //
                          if (Array.isArray(data)) {
                            let c = this.filters4Data.findIndex(
                              e => e.id === d.id
                            );
                            // JEW: shared labels (e.g. many "JEWSON LTD") get a pickerLabel that tells them apart
                            this.filters4Data[c] = withPickerLabels(data, pickerLabelKey(d, data));

                            if (d.lovEP === "v1/users") {
                              this.users = data;
                            } else if (d.lovEP === "v1/contacts") {
                              this.contacts = data;
                            }
                          }
                        })
                        .catch(err => {
                          if (
                            err &&
                            err.response &&
                            err.response.status !== 200
                          ) {
                            // this.$toast.add({
                            //   severity: "error",
                            //   summary: "Error",
                            //   detail: `Error while getting filter data from ${d.lovEP} for ${d.dbField}`,
                            //   life: 5000,
                            // })
                            this.$store.dispatch("addErrorMessage", {
                              severity: "error",
                              content: `Some data was not loaded from "${d.lovEP}"`
                            });
                          }
                        });
                    }
                  } else if (d.fieldType === "String") {
                    let c = this.filters4Data.findIndex(e => e.id === d.id);
                    this.filters4Data[c] = "";
                  }
                }
                this.makeDataTable();
              }
            });
            //
          })
          .catch(err => {
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting date modifiers",
            //   life: 5000,
            // })
            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content: 'Some data was not loaded from "dateModifiers"'
            });
          });
      })
      .catch(err => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting db view fields",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "dbViewFields/{dbView}"'
        });
      });
  },
  watch: {
    filterToEditConditions(val) {
      if (val && val[0]) {
        this.makeDataTable();
      }
    },
    contacts(val) {
      //
      if (val && val[0]) {
        this.makeDataTable();
      }
    },
    users(val) {
      //
      if (val && val[0]) {
        this.makeDataTable();
      }
    },
    filter2(val) {
      let i = this.filters2.findIndex(filter => filter.id === val.id);
      //

      if (Array.isArray(this.filters4Data[i])) {
        this.filter4Type = "Array";
        this.filters4 = [];
        this.filters4 = this.filters4Data[i];
        //
      } else if (this.filters4Data[i] && this.filters4Data[i].fieldType) {
        this.filter4Type = this.filters4Data[i].fieldType;

        if (this.filters4Data[i].fieldType === "Yes/No") {
          this.filters4 = [];
          this.filters4.push(this.yesFlag);
          this.filters4.push(this.noFlag);
        }
      } else if (this.filters2[i]) {
        if (this.filters2[i].lovEP) {
          this.filter4Type = "Array";
        } else {
          this.filter4Type = this.filters2[i].fieldType;
        }
      }

      this.filters3 = [];
      if (
        val.fieldType === "Number" ||
        val.fieldType === "Currency" ||
        val.fieldType === "Date"
      ) {
        this.filters3.push(this.filters3Data.find(a => a.value === "="));
        this.filters3.push(this.filters3Data.find(a => a.value === "≠"));
        this.filters3.push(this.filters3Data.find(a => a.value === ">"));
        this.filters3.push(this.filters3Data.find(a => a.value === "<"));
        this.filters3.push(this.filters3Data.find(a => a.value === ">="));
        this.filters3.push(this.filters3Data.find(a => a.value === "<="));
      } else if (val.fieldType === "String") {
        this.filters3.push(this.filters3Data.find(a => a.value === "equals"));
        this.filters3.push(
          this.filters3Data.find(a => a.value === "does not equal")
        );
        this.filters3.push(
          this.filters3Data.find(a => a.value === "begins with")
        );
        this.filters3.push(this.filters3Data.find(a => a.value === "contains"));
      } else if (val.fieldType === "List" || val.fieldType === "Yes/No") {
        this.filters3.push(this.filters3Data.find(a => a.value === "equals"));
        this.filters3.push(
          this.filters3Data.find(a => a.value === "does not equal")
        );
      } else {
        this.filters3 = this.filters3Data;
      }
    },
    filters(val) {
      this.filter2 = {};
      this.filter3 = {};
      this.filter4 = null;
    },
    filters2(val) {},
    filter4(val) {}
  },
  methods: {
    constructSortOrder() {
      //
      if (
        this.filterToEdit &&
        this.filterToEdit.orderByClause &&
        this.dbViewFields.length
      ) {
        var str = this.filterToEdit.orderByClause,
          strToShow = "",
          parts = str.split(",");
        parts.forEach((part, index) => {
          let loc = part.indexOf("DESC"),
            dbField = "",
            order = "";
          if (loc > -1) {
            order = "DESC";
          } else {
            loc = part.indexOf("ASC");
            if (loc > -1) {
              order = "ASC";
            }
          }
          if (loc > -1) {
            dbField = part.substring(0, loc - 1).trim();
            let found = this.dbViewFields.find(
              field => field.dbField === dbField
            );

            if (found) {
              if (index > 0) {
                strToShow = strToShow.concat(`, ${found.fieldName} ${order}`);
              } else {
                strToShow = `${found.fieldName} ${order}`;
              }
            }
          }

          if (index === parts.length - 1) {
            this.sortByFieldString({ str, strToShow });
          }
        });
      }
    },
    setSelection({ value, index }) {
      //
      this.filter4 = value;
    },
    editCondition(condition) {
      this.filter4 = "";

      //
      if (this.filters2) {
        let found1 = this.filters1.find(a => a.value === condition.gate);
        let found2Index = this.filters2.findIndex(
          a => a.dbField === condition.field
        );
        let found2 = this.filters2[found2Index];
        let found3 = this.filters3Data.find(
          a => a.value === condition.comparison
        );

        //
        if (found2 && found2.id && found3 && found3.id) {
          this.conditionsEditIndex = this.filters.findIndex(
            a =>
              a.gate === condition.gate &&
              a.field === condition.field &&
              a.comparison === condition.comparison &&
              a.value === condition.value
          );

          this.filter1 = found1;
          this.filter2 = found2;
          this.filter3 = found3;

          if (Array.isArray(this.filters4Data[found2Index])) {
            if (found2.fieldType === "Date") {
              let a = condition.value.split("/");
              //
              if (a.length === 3) {
                this.filter4 = this.filters4Data[found2Index].find(
                  a => a.dateModifierFunc === "custom"
                );
                this.tempDate = condition.value;
              } else {
                this.filter4 = this.filters4Data[found2Index].find(
                  a => a.dateModifierFunc === condition.value
                );
                this.tempDate = "";
              }
            } else {
              if (
                found2.filterAllowStartWith &&
                typeof condition.value === "string"
              ) {
                this.filter4 = condition.value;
              } else {
                // JEW-2: reopen on the account saved (its id), not the first with the same name
                this.filter4 = findConditionOptionById(
                  found2,
                  this.filters4Data[found2Index],
                  condition
                );
              }
              this.tempDate = "";
            }
          } else if (
            this.filters4Data[found2Index] &&
            this.filters4Data[found2Index].fieldType === "Yes/No"
          ) {
            if ((condition.value = "Yes")) {
              this.filter4 = this.yesFlag;
            } else {
              this.filter4 = this.noFlag;
            }
            this.tempDate = "";
          } else if (
            found2.fieldType === "Time" ||
            found2.fieldType === "String"
          ) {
            this.filter4 = condition.value;
            this.tempDate = "";
          } else if (
            found2.fieldType === "Number" ||
            found2.fieldType === "Currency"
          ) {
            this.filter4 = parseFloat(condition.value);
            this.tempDate = "";
          }

          this.conditionSelection = true;
        }
      }
    },
    getOrderByClauseFromChild(strToShow) {
      //
      this.strToShow = strToShow;
    },
    sortByFieldString({ str, strToShow }) {
      //
      this.strToShow = strToShow;
      this.filterDetails.orderByClause = str;
      this.orderByClause = str;
      this.sortByFieldsDialog = false;
    },
    makeDataTable() {
      //

      for (let i = 0; i < this.filterToEditConditions.length; i++) {
        let obj = {
          gate: this.filterToEditConditions[i].rowStart || "",
          field: this.filterToEditConditions[i].dbField
            ? this.filterToEditConditions[i].dbField.dbField
            : "",
          fieldToView: this.filterToEditConditions[i].dbField
            ? this.filterToEditConditions[i].dbField.fieldName
            : "",
          comparison: this.filterToEditConditions[i].condition,
          value: this.filterToEditConditions[i].value
            ? this.filterToEditConditions[i].value.trim()
            : "",
          dbField: this.filterToEditConditions[i].dbField
            ? this.filterToEditConditions[i].dbField.id
            : 0,
          // JEW-2: keep the stored id, so reopening and saving keeps the account picked
          dbValue: this.filterToEditConditions[i].dbValue,
          filter2: this.filterToEditConditions[i].dbField
        };

        this.filters[this.filterToEditConditions[i].rowNo - 1] = obj;
        //
        this.tableKey++;
      }
    },
    selectFieldsToSortBy() {
      this.sortByFieldsDialog = true;
    },
    getDataKey() {
      if (
        this.filter2 &&
        this.filter2.dbIdField &&
        this.filter2.fieldType !== "Date"
      ) {
        return this.filter2.dbIdField;
      } else if (
        this.filter2 &&
        this.filter2.fieldType === "Date" &&
        this.filters4
      ) {
        return "id";
      } else {
        return "";
      }
    },
    get4Label() {
      if (
        this.filter2 &&
        this.filter2.dbField &&
        this.filter2.fieldType !== "Date"
      ) {
        // JEW: options with shared labels carry a pickerLabel (display only; see pickerLabels.js)
        if (this.filters4 && this.filters4[0] && this.filters4[0].pickerLabel !== undefined) {
          return "pickerLabel";
        }
        if (
          this.filters4Data &&
          this.filters4[0] &&
          this.filters4[0][this.filter2.dbNameField]
        ) {
          return this.filter2.dbNameField;
        } else if (
          this.filters4Data &&
          this.filters4[0] &&
          this.filters4[0][this.filter2.dbField]
        ) {
          return this.filter2.dbField;
        } else {
          let a = "";
          a = this.filter2 ? this.filter2.dbField.split(".").slice(-1) : "";
          return a[0];
        }
      } else if (
        this.filter2 &&
        this.filter2.fieldType === "Date" &&
        this.filters4
      ) {
        return "dateModifierName";
      } else {
        return "";
      }
    },
    removeCondition(data) {
      let i = this.filters.findIndex(
        filter =>
          filter.comparison === data.comparison &&
          filter.field === data.field &&
          filter.gate === data.gate &&
          filter.value === data.value
      );
      this.filters.splice(i, 1);
    },
    openConditionDialog() {
      this.filter4 = null;
      this.fieldsEntered = false;
      this.conditionsEditIndex = -1;
      this.tempDate = "";
      this.conditionSelection = true;
    },
    edit() {
      this.fieldsEntered = true;

      if (
        this.conditionsEditIndex >= 0 &&
        this.filter2 &&
        this.filter2.id &&
        this.filter3 &&
        this.filter3.id &&
        this.filter4 !== null &&
        this.filter4 !== undefined
      ) {
        let tempObj = {};
        tempObj.field = this.filter2.dbField;
        tempObj.fieldToView = this.filter2.fieldName;
        tempObj.comparison = this.filter3.value;
        tempObj.dbField = this.filter2.id;
        tempObj.filter2 = this.filter2;

        // Same resolution as add(): a picked option is read by the field's dbNameField when it has one.
        tempObj.value = conditionValueFor(this.filter2, this.filter4, {
          tempDate: this.tempDate,
          filter4Type: this.filter4Type
        });
        // JEW-2: the picked option's id, so the save keeps the account picked (not the first same name)
        tempObj.dbValue = pickedDbValue(this.filter2, this.filter4);

        if (this.conditionsEditIndex > 0) {
          if (this.filter1 && this.filter1.id) {
            tempObj.gate = this.filter1.value;
            this.filters[this.conditionsEditIndex] = tempObj;
            this.conditionSelection = false;
            this.conditionsEditIndex = -1;
          }
        } else {
          this.filters[this.conditionsEditIndex] = tempObj;
          this.conditionSelection = false;
          this.conditionsEditIndex = -1;
        }
        //
      }
    },
    add() {
      //
      this.fieldsEntered = true;

      if (
        (this.filters.length === 0 &&
          this.filter2 &&
          this.filter2.id &&
          this.filter3 &&
          this.filter3.id &&
          this.filter4 !== null &&
          this.filter4 !== undefined) ||
        (this.filters.length > 0 &&
          this.filter1 &&
          this.filter1.id &&
          this.filter2 &&
          this.filter2.id &&
          this.filter3 &&
          this.filter3.id &&
          this.filter4 !== null &&
          this.filter4 !== undefined)
      ) {
        let a = {};
        a.field = this.filter2.dbField;
        a.fieldToView = this.filter2.fieldName;
        a.comparison = this.filter3.value;
        a.dbField = this.filter2.id;
        a.filter2 = this.filter2;

        a.value = conditionValueFor(this.filter2, this.filter4, {
          tempDate: this.tempDate,
          filter4Type: this.filter4Type
        });
        a.dbValue = pickedDbValue(this.filter2, this.filter4); // JEW-2
        //

        if (a.comparison && a.field && a.value !== null) {
          //
          if (this.filters.length > 0) {
            if (this.filter1 && this.filter1.id) {
              a.gate = this.filter1.value;
              this.filters.push(a);
              this.conditionSelection = false;
            }
          } else {
            this.filters.push(a);
            this.conditionSelection = false;
          }
        }
      }
    },
    addFilter() {
      this.submitted = true;
      this.sendingRequest = true;

      // this.filters2.forEach(filter2 => {
      //   if (filter2.dbView && filter2.dbView.className === 'CUSTOMER')
      // this.filterDetails.dbview = filter2.dbView.id
      // })
      this.filterDetails.dbview = this.getDBViewFieldsId;

      //
      filterSaveRequest(this, "filterForm.vue");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style></style>
